import { Grid2, MenuItem, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import DropDownSelect from "../../../component/Select";
import SnackBar from "../../../component/SnackBar";
import { HarizonAnalytics } from "../../../redux/action/Harizon";
import { CustomDiv } from "../../chat-bot/style";
import { SelectCreateCard } from "../../home/style";
import AnalyticsCard from "./components/AnalyticsCard";
import { useSelector } from "react-redux";
import { CommonGrid2 } from "../../common-components/StyledComponents";

export default function ReviewProductivity() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [timePeriodValue, setTimePeriodValue] = useState("");
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const harizonAnalytics = useSelector(
    (state) => state.harizon.harizonAnalytics
  );

  const fetchAnalytics = async ({ timePeriod = timePeriodValue }) => {
    try {
      let params = {
        filter_type: timePeriod,
      };
      setIsLoading(true);
      const data = await dispatch(HarizonAnalytics(params));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
    }
  };

  useEffect(() => {
    fetchAnalytics({});
  }, []);

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const dropDownOption = [
    {
      name: "Last Month",
      id: "last_month",
    },
    { name: "This Month", id: "this_month" },
    { name: "Last Week", id: "last_week" },
    { name: "This Week", id: "this_week" },
  ];

  const CustomMenuItem = (item, index) => (
    <MenuItem value={item?.id} key={index}>
      {item?.name}
    </MenuItem>
  );
  return (
    <CustomDiv padding="2rem">
      <Grid2 item size={{ xs: 12 }} paddingBottom={3}>
        <Typography variant="body6">Review Productitvity</Typography>
      </Grid2>
      <Grid2 item size={{ xs: 12 }}>
        <SelectCreateCard minHeight="100%" padding="20px" condition={false}>
          <CommonGrid2
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant="body4" color="#475E75" fontWeight={600}>
              Productivity Tracker
            </Typography>
            <DropDownSelect
              marginTop="0px"
              title={"Select Time Period"}
              InputPadding={"10px"}
              valueChange={true}
              data={dropDownOption || []}
              value={timePeriodValue}
              handleChange={(e) => {
                setTimePeriodValue(e.target.value);
                fetchAnalytics({ timePeriod: e.target.value });
              }}
              disabled={isLoading}
              customStyle={{
                width: "180px",
              }}
              CustomMenuItem={CustomMenuItem}
            />
          </CommonGrid2>
          <AnalyticsCard
            harizonAnalytics={harizonAnalytics}
            isLoading={isLoading}
          />
        </SelectCreateCard>
      </Grid2>
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
